"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnvironmentStateAdapter_Sync = exports.EnvironmentStateAdapter = void 0;
var EnvironmentStateAdapter = /*#__PURE__*/function () {
  function EnvironmentStateAdapter(implementation) {
    _classCallCheck(this, EnvironmentStateAdapter);
    this.implementation = implementation;
  }
  _createClass(EnvironmentStateAdapter, [{
    key: "setJson",
    value: function () {
      var _setJson = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, value) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.implementation.setString(key, JSON.stringify(value));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function setJson(_x, _x2) {
        return _setJson.apply(this, arguments);
      }
      return setJson;
    }()
  }, {
    key: "getJson",
    value: function () {
      var _getJson = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
        var val;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.implementation.getString(key);
            case 2:
              val = _context2.sent;
              if (!(val == null || val === "undefined" || val === "null")) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", undefined);
            case 5:
              return _context2.abrupt("return", JSON.parse(val));
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getJson(_x3) {
        return _getJson.apply(this, arguments);
      }
      return getJson;
    }()
  }, {
    key: "setString",
    value: function () {
      var _setString = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key, value) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.implementation.setString(key, value);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function setString(_x4, _x5) {
        return _setString.apply(this, arguments);
      }
      return setString;
    }()
  }, {
    key: "getString",
    value: function () {
      var _getString = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(key) {
        var val;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.implementation.getString(key);
            case 2:
              val = _context4.sent;
              if (!(val == null)) {
                _context4.next = 5;
                break;
              }
              return _context4.abrupt("return", undefined);
            case 5:
              return _context4.abrupt("return", val);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getString(_x6) {
        return _getString.apply(this, arguments);
      }
      return getString;
    }()
  }, {
    key: "createJsonGetterSetter",
    value: function createJsonGetterSetter(key) {
      var _this = this;
      return {
        get: function get() {
          return _this.getJson(key);
        },
        set: function set(value) {
          return _this.setJson(key, value);
        }
      };
    }
  }, {
    key: "createStringGetterSetter",
    value: function createStringGetterSetter(key) {
      var _this2 = this;
      return {
        get: function get() {
          return _this2.getString(key);
        },
        set: function set(value) {
          return _this2.setString(key, value);
        }
      };
    }
  }]);
  return EnvironmentStateAdapter;
}();
exports.EnvironmentStateAdapter = EnvironmentStateAdapter;
var EnvironmentStateAdapter_Sync = /*#__PURE__*/function () {
  function EnvironmentStateAdapter_Sync(implementation) {
    _classCallCheck(this, EnvironmentStateAdapter_Sync);
    this.implementation = implementation;
  }
  _createClass(EnvironmentStateAdapter_Sync, [{
    key: "setJson",
    value: function setJson(key, value) {
      this.implementation.setString(key, JSON.stringify(value));
    }
  }, {
    key: "getJson",
    value: function getJson(key) {
      var val = this.implementation.getString(key);
      if (val == null || val === "undefined" || val === "null") {
        return undefined;
      }
      return JSON.parse(val);
    }
  }, {
    key: "setString",
    value: function setString(key, value) {
      this.implementation.setString(key, value);
    }
  }, {
    key: "getString",
    value: function getString(key) {
      var val = this.implementation.getString(key);
      if (val == null) {
        return undefined;
      }
      return val;
    }
  }, {
    key: "clear",
    value: function clear(key) {
      this.implementation.clear(key);
    }
  }, {
    key: "createJsonGetterSetter",
    value: function createJsonGetterSetter(key) {
      var _this3 = this;
      return {
        get: function get() {
          return _this3.getJson(key);
        },
        set: function set(value) {
          return _this3.setJson(key, value);
        }
      };
    }
  }, {
    key: "createStringGetterSetter",
    value: function createStringGetterSetter(key) {
      var _this4 = this;
      return {
        get: function get() {
          return _this4.getString(key);
        },
        set: function set(value) {
          return _this4.setString(key, value);
        }
      };
    }
  }]);
  return EnvironmentStateAdapter_Sync;
}();
exports.EnvironmentStateAdapter_Sync = EnvironmentStateAdapter_Sync;